export interface Config {
  cleengEnv: "sandbox" | "prod";
  backendBaseUrl?: string;
}

const getCleengEnvFromDomain = (): "sandbox" | "prod" => {
  const hostname = window.location.hostname;
  return hostname === "betalen.talpanetwork.com" ? "prod" : "sandbox";
};

export const config: Config = {
  cleengEnv: getCleengEnvFromDomain(),
  backendBaseUrl: process.env.BACKEND_BASE_URL,
};

export const getCleengScriptUrl = (): string => {
  return config.cleengEnv === "prod"
    ? "https://widgets.prod.cleeng.com/cleeng.js"
    : "https://widgets.sandbox.cleeng.com/cleeng.js";
};

export const getBackendUrl = (path: string): string => {
  return config.backendBaseUrl ? `${config.backendBaseUrl}${path}` : path;
};
